Jelly.Interface.Autolink = function(Parameters)
{

	// TODO - lol
	if (typeof Autolinker === 'undefined'){
		console.log("punting autolinkr");
		setTimeout(function() {
			Jelly.Interface.Autolink(Parameters);
			},
			250
		);

		return;
	}
	

	// Autolink contents of element	
	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug)
	{
		Jelly.Debug.Group("Autolink");
		Jelly.Debug.Log(Parameters);
	}
		
	// Get element.
	if (typeof Parameters["Element"] === 'string' || Parameters["Element"] instanceof String)
		var Autolink_Element = document.getElementById(Parameters["Element"]);
	else
		var Autolink_Element = Parameters["Element"];
		
	// Autolink content for element.
	$(Autolink_Element).html(
		Autolinker.link(
				$(Autolink_Element).html()
			, {
				  newWindow:true
				, stripPrefix: false
				, stripTrailingSlash: true
				, phone: false
			}
		)
	);

	if (!Parameters.No_Icon)
		$(Autolink_Element).find('a').prepend('<i class="material-icons">open_in_new</i>');
	
	if (Debug)
		Jelly.Debug.End_Group("Autolink");
};